import useGetOpenOrders from '@hooks/useGetOpenOrders'
import useGetCompletedOrders from '@hooks/useGetCompletedOrders'
import useGetOrderById from '@hooks/useGetOrderById'
import { getFragmentData } from 'parkdepot-shared/gql'
import { OrderResponseFragment } from '@graphql/queries/getOpenOrders.query'
import { B2CCarpayOrderView } from 'parkdepot-shared/gql/graphql'

// Hook to get order data from cache first, to avoid unnecessary network requests.
// Use only if the current status of the order is not important.

const useGetOrderCacheFirst = ({ orderId, plate }: { orderId: string | null; plate: string | null }) => {
    const {
        data: openOrdersData,
        loading: openOrdersLoading,
        error: operOrderError
    } = useGetOpenOrders({
        variables: {
            plates: [plate!]
        },
        fetchPolicy: 'cache-only'
    })

    const openOrders = openOrdersData?.b2c_get_open_orders.orders.map((data) =>
        getFragmentData(OrderResponseFragment, data)
    )

    const openOrderData = openOrders?.find((order) => order.order.order_id === orderId)

    const {
        data: paidOrdersData,
        loading: paidOrdersLoading,
        error: paidOrderError
    } = useGetCompletedOrders({
        skip: !!openOrderData,
        variables: {
            plates: [plate!]
        },
        fetchPolicy: 'cache-only'
    })

    const paidOrders = paidOrdersData?.b2c_get_completed_orders.orders.map((data) =>
        getFragmentData(OrderResponseFragment, data)
    )

    const paidOrderData = paidOrders?.find((order) => order.order.order_id === orderId) as B2CCarpayOrderView

    const {
        data: orderByIdData,
        loading: orderByIdLoading,
        error: orderByIdError
    } = useGetOrderById({
        skip: !!openOrderData || !!paidOrderData,
        fetchPolicy: 'cache-first',
        variables: { order_id: orderId! }
    })

    const orderFetchedById = orderByIdData?.b2c_get_order_by_id

    const order = openOrderData || paidOrderData || orderFetchedById
    const loading = openOrdersLoading || paidOrdersLoading || orderByIdLoading
    const error = operOrderError || paidOrderError || orderByIdError

    return { order, loading, error }
}

export default useGetOrderCacheFirst
